import { getStatsUrl } from 'easit--utils';
import { gAService, StatisticsInApi } from 'eTip--common';

export class EventStatsTipos {
    viewStatistics = (statistics: StatisticsInApi | null, eventName?: string) => {
        const statUrl = getStatsUrl(statistics);
        gAService.sendEvent('BRStats', 'open', eventName);

        if (__IsMTS__) {
            window.open(statUrl, '_blank');
        }
        else {
            window.open(statUrl, 'Statistics', 'width=1100,status=yes,toolbar=no,menubar=no,location=no,resizable=yes,scrollbars=yes');
        }

    };
}
